//https://stackoverflow.com/questions/71086276/typeerror-u-readfile-is-not-a-function-in-angular
import React from 'react';
import jsPDF from "jspdf"
import autoTable from 'jspdf-autotable'
// import { Link } from 'react-router-dom';
// import './Lucida Calligra Regular-normal';
import { font } from "./Lucida Calligra Regular-normal";
import { fontt } from "./Zapfino-normal";
import { subdir, wwwdir } from "./logo";

const ExportToPdf = ({ data, cicle, yyear }) => {

  const exportExcel = async () => {


    // console.log(data)

    var ciclo = cicle
    // this.loading = "false"
    const doc = new jsPDF({
      // orientation: "landscape",
      // unit: "in",
      // format: [4, 2]
    })

    const indice = data.map(e => e._id).indexOf(cicle)
    var cntr = doc.internal.pageSize.width / 2
    // doc.table(10, 10, data, header, config);
    console.log(data[indice].mencions[0], cicle)
    console.log(indice)
    var users = data[indice].mencions[0].cycles
    var credito = 0
    var nota = 0
    var neww = []
    for (var i = 0; i < users.length; i++) {
      if (users[i].ciclo === ciclo) {
        var www = [users[i].title, users[i].year, users[i].credito, users[i].nota, users[i].credito * users[i].nota]//.concat(calification)
        neww.push(www);
        nota += + users[i].nota * users[i].credito
        credito += + users[i].credito
      }
    }

    // var foto2 = new Image()
    // foto2.src = './logo.png'
    // doc.addImage(foto2, 'png', doc.internal.pageSize.width - 53, 27.7, 32.5, 32.5)

    doc.setLineWidth(16)
    doc.setDrawColor(255, 255, 255);
    // doc.setFillColor(255, 0, 0)
    doc.circle(2 * cntr - 36.9, 43.9, 23.5, 'S')
    doc.setLineWidth(0);
    doc.setDrawColor(0)

    autoTable(doc, {
      margin: { horizontal: 12, top: 59 },
      startY: 0.25 * doc.internal.pageSize.height,
      styles: { overflow: 'linebreak' },
      styles: { fillColor: 'wheat' },
      columnStyles: { 0: { halign: 'center' } },
      //fillColor: [255, 255,   250] }  Cells in first column centered and green
      // margin: { top: 59 },
      head: [['CURSO', 'AÑO', 'CRÉDITO', 'NOTA', 'PUNTAJE']],
      foot: [["TOTAL", "", credito, "", nota],
      ["PROMEDIO SEMESTRAL", "", "", "", (nota / credito).toFixed(2)]
      ],
      body: neww,
    })

    var meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre']


    doc.setFontSize(18)
    // doc.setTextColor(1, 198, 255);
    doc.text("BOLETA DE NOTAS SEMESTRAL", cntr, 29, { align: 'center' });
    doc.setFontSize(16)
    doc.text(`CICLO ${ciclo}`, cntr, 36, { align: 'center' });
    doc.setFontSize(12)
    doc.setTextColor(0, 0, 0);
    doc.text("Escuela Superior de Bellas Artes Publica Ayacucho", cntr, 43, { align: 'center' });
    doc.setFontSize(9)
    doc.text("ESFAP 'FELIPE GUAMÁN POMA DE AYALA'", cntr, 48, { align: 'center' });
    doc.setFontSize(7)
    doc.text('Ayacucho, ' + new Date().getDate() + ' de ' + meses[new Date().getMonth()] + ' del ' + new Date().getFullYear(), cntr, 51, { align: 'center' });
    doc.setFontSize(12)
    doc.setTextColor(0, 0, 0);


    doc.text(JSON.parse(localStorage.getItem("user")).name, cntr, 59, { align: 'center' });
    doc.text(JSON.parse(localStorage.getItem("user")).mencion === 'P' ? "ARTES PLÁSTICAS (Pintura)" : JSON.parse(localStorage.getItem("user")).mencion === 'E' ? "ARTES PLÁSTICAS (Escultura)" :
      JSON.parse(localStorage.getItem("user")).mencion === 'G' ? "ARTES PLÁSTICAS  Y VISUALES (Grabado)" : "ARTES PLÁSTICAS Y VISUALES (Educación Artística)", cntr, 65, { align: 'center' });

    var imgData = 'data:image/jpeg;base64,' + subdir
    doc.addImage(imgData, 'jpeg', cntr - 21, 235, 95, 37, "", 'NONE', -5)
    var imgData2 = 'data:image/jpeg;base64,' + wwwdir
    doc.addImage(imgData2, 'png', cntr - 65, 205, 89.8, 39, "", 'NONE', 19)

    // var img3 = new Image()
    // img3.src = './esfap.jpg'
    // img3.onload = function () {
    // doc.addImage(img3, 'jpg', 21, 28.8, 35, 31)
    doc.save(JSON.parse(localStorage.getItem("user")).name + " Calificaciones del ciclo " + ciclo + ".pdf");
    // }
  }






  const onchange = async () => {
    const wwwww =
    {
      "_id": "62cf8d3194bde2c00225a36f",
      "title": "Random Text Generator is a web application",
      "institute": "Random Text Generator is a web application which provides true random text which you can use in your documents or web designs",
      "code": "62cf8d3194bde2c00225a36f",
      "description": "Random Text Generator is a web application which provides true random text which you can use in your documents or web designs. How does it work? First we took many books available on project Gutenberg and stored their contents in a database. Then a computer algorithm takes the words we stored earlier and shuffles them into sentences and paragraphs. The algorithm takes care to create text that looks similar to an ordinary book but without any real meaning.",
      "new": "The reason we want our text to be meaningless is that we want the person viewing the resulting random text to focus on the design we are presenting, rather than try to read and understand the text.",
      "user": "George, Charles Edward",
      "type": "DIPLOMADO",
      "signature1": "George, Charles Edward",
      "signature2": "George, Charles Edward",
      "signature3": "George, Charles Edward",
      "updatedAt": "2026-02-17T02:27:57.149Z",
      "__v": 0,
      "responce": null,
      "file": "uploads/collection/4e464faa-430e-4b3b-ae50-71a7a0db3a1b.jpg"
    }
    const doc = new jsPDF({ unit: 'cm', orientation: "landscape", format: [32, 21] })

    doc.addFileToVFS('Zapfino.ttf', fontt);
    doc.addFont('Zapfino.ttf', 'Zapfino', 'normal');

    // doc.addFileToVFS('Lucida Calligra Regular-normal.ttf', font);
    // doc.addFont('Lucida Calligra Regular-normal.ttf', 'Lucida Calligra Regular', 'normal');
    // doc.setFont("Lucida Calligra Regular");

    doc.advancedAPI(() => {
      doc.saveGraphicsState();
      // Use DOMMatrix to create a transformation matrix (translate, rotate, scale)
      let { a, b, c, d, e, f } = new DOMMatrix()
        .translate(-5, doc.internal.pageSize.height / 2)
        .rotate(-45);

      doc.setCurrentTransformationMatrix(doc.Matrix(a, b, c, d, e, f));
      // Draw the shape at a relative origin (e.g., 0, 0)
      for (let i = 1; i < 6; i++) {
        // doc.rect(0, 0, doc.internal.pageSize.width, doc.internal.pageSize.height, 'S');
        doc.setLineWidth(5 / i)
        doc.setDrawColor(155, 155, 35 * i)
        // doc.setFillColor(155, 155, 155)
        let offset = 10;
        doc.rect(-3 + i, 1 + i, 36 - (2 * i), 23 - (2 * i), 'S');
        // doc.rect(0, 0, doc.internal.pageSize.width - i, doc.internal.pageSize.height - i, 'S');
      }
      doc.fill();
      doc.restoreGraphicsState();
    })

    doc.setLineWidth(.1)
    doc.setFillColor(255, 255, 255)

    doc.setDrawColor(255, 255, 255)
    doc.roundedRect(.5, .5, doc.internal.pageSize.width - 1, doc.internal.pageSize.height - 1, 1, 1, 'S')
    doc.setDrawColor(255, 35, 0)
    doc.roundedRect(1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2, 1, 1, 'FD')

    const widthh = doc.internal.pageSize.width
    const heightt = doc.internal.pageSize.height

    doc.setFont('courier', 'normal')
    var ytag = 3;
    doc.setFontSize(21)
    var splittedText = doc.splitTextToSize(wwwww.institute, 2 * widthh / 3)
    var lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    var blockHeight = splittedText.length * lineHeight
    doc.text(splittedText, widthh / 2, ytag, { maxWidth: 2 * widthh / 3, align: 'center' })
    ytag += blockHeight + 1

    doc.setFont("Zapfino");
    doc.setFontSize(29)
    var splittedText = doc.splitTextToSize(wwwww.title, 3 * widthh / 2)
    var lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    var blockHeight = splittedText.length * lineHeight
    doc.text(splittedText, widthh / 2, ytag, { maxWidth: 3 * widthh / 2, align: 'center' })
    ytag += blockHeight + .5

    doc.setFont('courier', 'normal')

    doc.setFontSize(14)
    doc.text(wwwww.description, widthh / 19, ytag, { maxWidth: 17 * widthh / 19, align: 'justify' })
    var splittedText = doc.splitTextToSize(wwwww.description, 17 * widthh / 19)
    var lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    var blockHeight = splittedText.length * lineHeight
    ytag += blockHeight + .5

    doc.text(wwwww.new, widthh / 19, ytag, { maxWidth: 17 * widthh / 19, align: 'justify' })
    var splittedText = doc.splitTextToSize(wwwww.new, 17 * widthh / 19)
    var lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    var blockHeight = splittedText.length * lineHeight

    ytag += blockHeight + .5
    doc.text(wwwww.updatedAt, widthh / 19, ytag, { maxWidth: 17 * widthh / 19, align: 'justify' })
    ytag += 1
    doc.text(wwwww.code, widthh / 19, ytag, { maxWidth: 17 * widthh / 19, align: 'justify' })
    ytag += 1
    doc.text(wwwww.code, widthh / 19, ytag, { maxWidth: 17 * widthh / 19, align: 'justify' })


    doc.setFont('courier', 'bold')
    doc.setFontSize(15)
    doc.setTextColor(1, 198, 255);

    doc.text(wwwww.signature1, 1 * widthh / 6, 14.5 * heightt / 16, { maxWidth: 2 * widthh / 6, align: 'center' });
    doc.text(wwwww.signature2, 3 * widthh / 6, 14.5 * heightt / 16, { maxWidth: 2 * widthh / 6, align: 'center' });
    doc.text(wwwww.signature3, 5 * widthh / 6, 14.5 * heightt / 16, { maxWidth: 2 * widthh / 6, align: 'center' });

    // (interior) agregar imagen(imageData, formato, x, y, ancho, alto, alias, compresión, rotación)
    var imgData = 'data:image/jpeg;base64,' + subdir
    doc.addImage(imgData, 'jpeg', 3, 16, 8, 2, "", 'NONE', -1)
    var imgData2 = 'data:image/jpeg;base64,' + wwwdir
    doc.addImage(imgData2, 'png', 21, 16, 8, 2, "", 'NONE', 1)


    // Save the generated PDF
    doc.save('downloaded-pdf-with-image.pdf');
    // };


    // Handle potential errors if the image fails to load
    // myImage.onerror = function () {
    //   console.error("Error loading image");
    // };

  }

  return (
    <>
      <button onClick={onchange} className='btn btn-primary'>IMPRIMIR DIPLOMA</button>
    </>
  )
}

export default ExportToPdf





